import { useCallback } from 'react';
import { AuthUser } from '../../../services/authService';
import { persistUserBalance } from '../services/userService';

interface UseUserBalanceProps {
  user: AuthUser | null;
  accessToken: string | null;
  apiBaseUrl: string;
  refreshAccessToken: () => Promise<string | null>;
  updateUser: (user: AuthUser) => void;
}

/**
 * 사용자 잔고 관리 훅
 */
export const useUserBalance = ({
  user,
  accessToken,
  apiBaseUrl,
  refreshAccessToken,
  updateUser,
}: UseUserBalanceProps) => {
  const persistBalance = useCallback(
    async (balance: number, gamesPlayedIncrement = 0) => {
      return persistUserBalance(
        { balance, gamesPlayedIncrement },
        {
          user,
          accessToken,
          apiBaseUrl,
          refreshAccessToken,
          updateUser,
        }
      );
    },
    [user, accessToken, apiBaseUrl, refreshAccessToken, updateUser]
  );

  return {
    persistBalance,
  };
};

